import { render } from "./HoriSlide.vue?vue&type=template&id=45bcabac&scoped=true&ts=true"
import script from "./HoriSlide.vue?vue&type=script&lang=ts"
export * from "./HoriSlide.vue?vue&type=script&lang=ts"

import "./HoriSlide.vue?vue&type=style&index=0&id=45bcabac&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/A-生产-h5-prod/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45bcabac"]])

export default __exports__